export enum TrackerType {
  Note = 'note',
  Number = 'number',
  Percent = 'percent',
  YesNo = 'yesno',
}
